import * as React from 'react';

import type { AddressModel } from 'ab-viewModels/scheduleBoardWorkOrderModal.viewModel';

import NonEditableMap from 'af-components/Maps/NonEditableMap';

import styles from './styles.module.scss';

interface OwnProps {
	address: AddressModel;
	isRemoved?: boolean;
}

type Props = OwnProps;

const _formatStreet = (address: AddressModel) => {
	const { streetNumber, street, city, neighborhood, country, state } = address;
	const streetArray: string[] = [];
	if (street) {
		streetArray.push(street);
	}
	if (neighborhood) {
		streetArray.push(neighborhood);
	}
	if (city) {
		streetArray.push(city);
	}
	if (state) {
		streetArray.push(state);
	}
	if (country) {
		streetArray.push(country);
	}
	return `${streetNumber ? streetNumber : ''} ${streetArray.join(', ')}`;
};

const Address: React.FC<Props> = (props) => {
	const { address, isRemoved = false } = props;

	const location = React.useMemo(() => {

		return address.latitude && address.longitude
			? {
				lat: address.latitude,
				lng: address.longitude,
			}
			: null;
	}, [address.latitude, address.longitude]);

	const className = React.useMemo(() => {
		const classNames = [styles['work-locations__work-location']];
		if (isRemoved) {
			classNames.push(styles['work-locations__work-location--removed']);
		}
		return classNames.join(' ');
	}, [isRemoved]);

	return (
		<div className={className}>
			<div>
				<strong>{_formatStreet(address)}</strong>
			</div>
			<div>{address.notes}</div>
			{(location && !isRemoved) &&
				<NonEditableMap
					additionalContainerClassName={styles['work-locations__map-container']}
					location={location}
				/>
			}
		</div>
	);
};

export default React.memo(Address);
